import { render, staticRenderFns } from "./oderAdUpLoad.vue?vue&type=template&id=5422cfa4&scoped=true&"
import script from "./oderAdUpLoad.vue?vue&type=script&lang=js&"
export * from "./oderAdUpLoad.vue?vue&type=script&lang=js&"
import style0 from "./oderAdUpLoad.vue?vue&type=style&index=0&id=5422cfa4&scoped=true&lang=css&"
import style1 from "./oderAdUpLoad.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5422cfa4",
  null
  
)

export default component.exports